/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { withLocalization } from 'hocs/localization'
import SuccessForgotPassEmailSending from './SuccessForgotPassEmailSending'

export default compose(
  withLocalization('home.forgot.success'),
)(SuccessForgotPassEmailSending)
